'use client';
import dynamic from 'next/dynamic';
import HireProcess from '@/components/technologies/hire-process';
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import WhyChooseUs from '@/components/technologies/why-choose-us';
import DefaultBreadcrumb from '@/components/common/breadcrumbs';
import YiiModelsOfWorking from '@/components/technologies/yii-models-of-working';
import MetaTags from '@/components/meta-tag/meta-tag';
import Blog from '@/components/home/blog';

const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));

const TechHero = dynamic(() => import('@/components/technologies/tech-hero'));
const ContetVideoSection = dynamic(() => import('@/components/common/content-video'));
const Page = () => {
    return (
        <>
            <MetaTags />
            <TechHero
                className=""
                desc="Experience Dynamic Combination of Ease and Reliability with Yii Web Development Services"
                alt="Full Stack Development"
                title="Full Stack Development"
                width={1090}
                height={604}
                path={'yii-development-hero'}
                bgPath={'hero-bg-grunge-orange'}
                color="orange"
                isOrange={true}
            >
                Yii Development
            </TechHero>

            <DefaultBreadcrumb parentPage="Technologies" isParent={true} currentPage="Yii Development" />
            <ContetVideoSection title="Address Your Business Needs with Secure and Scalable PHP-MySQL Solutions">
                <>
                    <p className="fw-400 text-secondary fs-md">
                        If steadiness, security, and adroitness is something that you expect in your business website, then opting
                        the blend of Yii framework development services – A leading PHP framework and MySQL as a relational
                        database can be the most appropriate platform. Yii’s framework ability to function on almost all platforms
                        and MySQL’s strength to manage huge chunks of data in structured format make them a perfect blend and the
                        primary choice of developers to develop a scalable business solution. Ensure smooth, interactive and
                        result-oriented business solution with PHP-MySQL Development.
                    </p>
                </>
            </ContetVideoSection>
            <HireProcess
                bg="bg-yii"
                pageTitle="Hire Custom Yii Developers To Build Cutting-Edge Digital Products"
                desc="Get a free consultation from our experts who will brainstorm your project idea to convert it into an advanced digital product using Yii."
            />
            <WhyChooseUs pageTitle="Why Clients Choose Moweb for Yii Consulting?" />

            <YiiModelsOfWorking
                title="Engagement models to hire the best Yii Developers"
                desc="Select from different engagement models to hire Yii Developers for your business needs. Different types of engagements allow you to find an optimal match for your company’s specific needs; whether that means hiring expert developers, or being flexible enough to change when necessary."
            />
            <CaseStudies />
            <section className="">
                <ClientTestimonials />
            </section>
            <Blog />
            <div className="section bg-primary py-100 dark:text-light dark:bg-black">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
